var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRwShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 24",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 1.71111L2.06667 4.02222C1.72335 4.47997 1.55169 4.70885 1.55568 4.90043C1.55914 5.06715 1.63732 5.2235 1.76861 5.32631C1.91949 5.44444 2.20558 5.44444 2.77778 5.44444H19.2222C19.7944 5.44444 20.0805 5.44444 20.2314 5.32631C20.3627 5.2235 20.4409 5.06715 20.4443 4.90043C20.4483 4.70885 20.2766 4.47997 19.9333 4.02222L18.2 1.71111M3.8 1.71111C3.99555 1.45037 4.09333 1.32 4.21725 1.22597C4.327 1.14269 4.45129 1.08055 4.58376 1.04272C4.73333 1 4.8963 1 5.22222 1H16.7778C17.1037 1 17.2667 1 17.4162 1.04272C17.5487 1.08055 17.673 1.14269 17.7827 1.22597C17.9067 1.32 18.0044 1.45037 18.2 1.71111M3.8 1.71111L1.71111 4.49629C1.44727 4.84809 1.31534 5.02398 1.22166 5.21769C1.13854 5.38958 1.07791 5.57146 1.04128 5.75884C1 5.97001 1 6.18988 1 6.62963L1 19.6667C1 20.9112 1 21.5335 1.24221 22.0089C1.45526 22.427 1.79522 22.767 2.21335 22.98C2.68871 23.2222 3.31099 23.2222 4.55556 23.2222L17.4444 23.2222C18.689 23.2222 19.3113 23.2222 19.7866 22.98C20.2048 22.767 20.5447 22.427 20.7578 22.0089C21 21.5335 21 20.9112 21 19.6667V6.62963C21 6.18989 21 5.97002 20.9587 5.75884C20.9221 5.57146 20.8615 5.38958 20.7783 5.21769C20.6847 5.02399 20.5527 4.84809 20.2889 4.4963L18.2 1.71111M15.4444 9.88889C15.4444 11.0676 14.9762 12.1981 14.1427 13.0316C13.3092 13.8651 12.1787 14.3333 11 14.3333C9.82126 14.3333 8.6908 13.8651 7.8573 13.0316C7.02381 12.1981 6.55556 11.0676 6.55556 9.88889",
    stroke: "url(#paint0_linear_1226_1411)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1226_1411",
    x1: 13.5208,
    y1: 11.7279,
    x2: 10.5347,
    y2: 11.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwShop);
export default __webpack_public_path__ + "static/media/RWShop.173db47781869f1d66d41e4355d7aeab.svg";
export { ForwardRef as ReactComponent };